import { ProvisionTypeEnum } from 'Common/Constants/Enumeration/ProvisionTypeEnum';

export const ProvisionTypeOptions = [
  { key: ProvisionTypeEnum.BOTH, value: ProvisionTypeEnum.BOTH, label: 'Both' },
  {
    key: ProvisionTypeEnum.CEP_PROVISION_2,
    value: ProvisionTypeEnum.CEP_PROVISION_2,
    label: 'CEP/Provision 2',
  },
  {
    key: ProvisionTypeEnum.TRADITIONAL,
    value: ProvisionTypeEnum.TRADITIONAL,
    label: 'Traditional',
  },
];



// WEBPACK FOOTER //
// ./src/common/Constants/ProvisionTypeOptions.js